<template lang="pug">
    .container.content.evaluation(v-if="contents && contents.length" ref="container")
        transition-group(name="fade")
            Information(
                v-for="info in currentInformations"
                :key="info.id"
                :information="info"
                :answered="info.answered"
                :section="section"
            )
        .button-row.action-buttons.is-flex
            button.button.is-primary.returnButton(@click="goBack" :disabled="!canGoBack" v-if="!finished")
                span.icon.is-large
                    i.fas.fa-backspace
                | &nbsp;&nbsp;&nbsp;zurück
            button.button.is-primary.nextInformationButton(
                v-if="hasItems && !isLast"
                @click="nextInformation"
                :disabled="disabled"
            )  weiter&nbsp;&nbsp;&nbsp;
                span.icon.is-large
                    i.fas.fa-2x.fa-play-circle
            button.button.is-primary.lastInformationButton(
                v-else-if="hasItems==false && finished==false || isLast && finished == false"
                :disabled="disabled"
                @click="finishEvaluation"
            ) Umfrage beenden
        article.message.is-info.column.is-10.is-offset-1.speech-bubble.bubble-left(
            v-if="finished"
        )
            .message-header
                p Vielen Dank für Ihre Antworten!
            .message-body
            | Wie möchten Sie mit der Umfrage fortfahren?
            .button-row
                button.button.end-of-eval-button.is-primary(@click="saveEvaluation('print')") ausdrucken
                button.button.end-of-eval-button.is-primary(@click="saveEvaluation('publish')") auf UWID veröffentlichen
        .progress-wrap.column.is-offset-1.is-10(v-if="!finished")
            .evalprogress
                .current-evalprogress(:style="{ width: currentProgress + '%' }")
            p.progress-percentage {{ currentProgress }}%

</template>

<script>

import get from 'lodash/get'
import findIndex from 'lodash/findIndex'
import last from 'lodash/last'
import has from 'lodash/has'
import debounce from 'lodash/debounce'
import findLastIndex from 'lodash/findLastIndex'

import Heading from './Heading'
import PostImage from './PostImage'
import Information from './Information'

import store from '@/store';
import router from '@/router'

import { mapGetters } from 'vuex'

export default {
    name: 'Evaluation',
    data() {
        return {
            currentInformationIndex: 0,
            nextInformationID: undefined,
            currentInformations: [],
            currentInformation: undefined,
            containerWidth: undefined,
            hasItems: undefined,
            currentProgress: 0,
            disabled: true
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Heading,
        PostImage,
        Information
    },
    computed: {
        canGoBack(){
            if(this.currentInformationIndex == 0) return false
            return true
        },
        contents() {
            return this.section.contents || []
        },
        heading() {
            return this.contents.find(content => content.key === 'heading')
        },
        content() {
            return this.contents.find(content => content.key === 'content')
        },
        images() {
            return this.contents.filter(content => content.key === 'information-image')
        },
        imagePosition() {
            let position = 'left-float'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image{_}position')
                if (setting && setting.value !== undefined) position = setting.value
            }

            return position
        },
        informations() {
            let informations = _.get(this.section, 'informations', [])
            return informations.sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0))
        },
        information() {
            let information = get(this.informations , this.currentInformationIndex, [])
            this.currentInformation = information

            return information
        },
        finished() {
            return this.evaluation.finished
        },
        isLast() {
            if(this.currentInformation == last(this.informations)) return true
            return false
        },
        ...mapGetters({
            evaluation: 'currentPage/evaluation'
        })
    },
    methods: {
        nextInformation() {
            this.currentInformationIndex = this.getIndex()
            let nextInformationIndex = false
            this.currentInformation.reactions.forEach((item, index) => {
                if ( item.input_type === 'nextInformation' || (item.contents[0].nextInformation != null && item.id == this.evaluation.informations[this.currentInformation.id].answer)) {
                    this.nextInformationID = item.contents[0].nextInformation.id
                    nextInformationIndex = findIndex(this.informations, ['id', item.contents[0].nextInformation.id])
                }
            })
            this.currentProgress = Math.round((this.currentInformation.position + 1) / this.informations.length * 100)
            this.currentInformations[this.currentInformationIndex].answered = true
            if(this.hasItems) {
                if (! nextInformationIndex ) {
                    this.currentInformationIndex = findIndex(this.informations, ['position', this.currentInformation.position + 1])
                } else {
                    this.currentInformationIndex = nextInformationIndex
                }
                this.currentInformations.push(this.information)
                if (this.information == last(this.informations)) {
                    this.hasItems = false
                }
                if (this.information.reactions.length == 0) this.nextInformation()
                if (has(this.currentInformation, 'reactions') && this.currentInformation.reactions.length >= 1 && this.currentInformation.reactions[0].input_type !== 'nextInformation') this.disabled = true
            }
        },
        getIndex() {
            return findIndex(this.currentInformations, ['id', this.currentInformation.id])
        },
        finishEvaluation() {
            let currentIndex = this.getIndex()
            this.currentInformations[currentIndex].answered = true
            store.commit('currentPage/evaluationFinish')
        },
        saveEvaluation(option) {
            if (option === 'publish') {
                const route = '/digitales-werkzeug/neu'
                if (this.evaluation.finished == true > 0) {
                    let results = this.currentInformations
                    results.forEach(item => {
                        if( this.evaluation.informations[item.id] ) {
                            item.answer = this.evaluation.informations[item.id].answer
                            let index = findIndex(item.reactions, ['id', item.answer])
                            item.reactions[index].contents[0].text = this.evaluation.informations[item.id].reactions[item.answer].value
                        }
                    })
                    store.commit('currentPage/evaluationSave', results)
                    router.push(route)
                }
            }else if (option === 'print') {
                window.print()
            }
        },
        goBack() {
            if(this.currentInformationIndex != 0){
                this.currentInformations.splice(this.currentInformationIndex, 1)
                this.currentInformationIndex = findLastIndex(this.currentInformations)
                this.currentInformation = this.informations[this.currentInformationIndex]
                if(this.currentInformations[this.currentInformationIndex].answered){
                    this.currentInformations[this.currentInformationIndex].answered = false
                }
                this.disabled = false
                if (this.information == last(this.informations)) {
                    this.hasItems = false
                }else{
                    this.hasItems = true
                }
                this.currentProgress = Math.round((this.currentInformation.position + 1) / this.informations.length * 100)
                store.commit('currentPage/evaluationUnfinish')
            }
            console.log(this.currentInformationIndex)
        }
    },
    mounted() {
        if (this.informations.length) this.hasItems = true
        if (this.hasItems) {
            this.currentInformations.push(this.information)
        } else {
            this.disabled = false
        }
        if (this.imagePosition === 'left-float') {
            this.containerWidth = 320
        } else {
            const calculateMaxWidth = () => {
                if (this.$refs.container) {
                    const style = getComputedStyle(this.$refs.container)
                    this.containerWidth = this.$refs.container.clientWidth
                    this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                }
            }

            window.addEventListener('resize', debounce(calculateMaxWidth, 100))
            calculateMaxWidth()
        }
    },
    created() {
        this.$store.subscribe((mutation, state) => {
            if(mutation.type === 'currentPage/evaluationReactionInputFieldValue') {
                if ( get(state.currentPage.evaluation, `informations.${this.currentInformation.id}.reactions`) && mutation.payload.value != '') {
                    this.disabled = false
                } else {
                    this.disabled = true
                }
            }
        })
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import "@/assets/sass/variables.sass";

    .section.post
        // .images
        //     display: flex
        //     .post-image
        //         margin-right: 10px
        //         /deep/ img
        //             height: auto
        //             max-width: 100%
        //             width: initial
        //         &:last-child
        //             margin-right: 0
        +tablet
            .content-wrap
                // display: flex
                // flex-direction: row
                // flex-flow: row-reverse
                .images.left-float
                    float: left
                    // width: 320px
                    display: block
                    // flex-shrink: 0
                    margin-right: 30px
                    padding-top: 6px
                .images.top-block
                    margin-bottom: 25px
                    display: flex
                    flex-direction: column
                    align-items: center
    .evaluation
        background-color: #dae3e8
        padding-top: 24px
        padding-bottom: 24px
        .header
            background-color: $primary
    .fade-enter-active, .fade-leave-active
        transition: opacity 2s
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
        opacity: 0
    .nextInformationButton
        width: 120px
        height: 50px
        .icon
            padding-left: 15px
    .button-row
        margin-right: 8.33333%
        padding-right: 0.75rem
        justify-content: space-between
        margin-top: 15px
        padding-bottom: 24px
    .action-buttons
        margin-left: 9.2%
    .speech-bubble
        background-color: #fff
        border-radius: 10px
    .speech-bubble:after
        position: absolute
        content: ""
        width: 0
        height: 0
        border-style: solid
    .bubble-left
        box-shadow: 4px 3px 10px -1px rgba(0,0,0,0.75)
        position: relative
    .bubble-left:after
        border-width: 10px 10px 10px 0
        top: 15px
        left: -10px
        border-color: transparent #fff transparent transparent
    .end-of-eval-button
        margin-right: 10px
        &:last-of-type
            margin-right: 0
    .progress-wrap
        .evalprogress
            border-radius: 3px
            height: 6px
            background-color: #eee
            padding: 0
            .current-evalprogress
                border-radius: 3px
                background-color: $primary
                z-index: 0
                height: 100%
                transition: 1s ease
        .progress-percentage
            position: absolute
            left: 50%
            color: $primary
            z-index: 1
</style>
<style>

@media print{
    .section.heading,
    .section.post,
    .message{
      display:none
    }
    header,
    footer{
      display:none
    }
}
</style>
